export default __webpack_public_path__ + "static/media/gritroutdoors.5a5c6eef.jpg";